/// <amd-module name="Core/Medius.Core.Web/Scripts/components/procurement/validatorConfiguration/validatorConfiguration"/>

export interface ValidatorConfiguration {
    activeValidators: string[];
}

export const PurchaseRequisitionLineSupplierCurrencyValidator = "Medius.Procurement.Platform.Validators.PurchaseRequisition.PurchaseRequisitionLineSupplierCurrencyValidator";
export const PurchaseRequisitionSupplierRequiredValidator = "Medius.Procurement.Platform.Validators.PurchaseRequisition.PurchaseRequisitionSupplierRequiredValidator";